import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";
import {PdfFormTemplateModel} from "../../models/pdf-form-template.model";

export class PdfFormTemplatesTableRowComponent implements IController {
  pdfFormTemplate: PdfFormTemplateModel;
  onDelete: Function;
  onEdit: Function;

  /* @ngInject */
  constructor() {

  }

  $onInit() {

  }

  $onChanges(changes) {

  };


}

angular
  .module('bringoz.admin.document-management')
  .component('pdfFormTemplatesTableRow', {
    bindings: {
      pdfFormTemplate: '<',
      onDelete: '&',
      onEdit: '&'
    },
    template: require('./pdf-form-templates-table-row.html').default,
    controller: PdfFormTemplatesTableRowComponent
  });
